
import React, { MouseEvent, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { useWindowSize } from 'react-use';

import { currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSearchBoxShowAtom, isSaveLoadingAtom } from 'library/store';

import useUtils from 'library/utils';

import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { Chip, makeStyles, MenuItem, TextField } from '@mui/material';

import { useTheme } from '@mui/material/styles';


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!

import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UndoIcon from '@mui/icons-material/Undo';

import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import useSchoolYearService, { useBasicFilterSchoolYear, useBasicFilterSchoolYearClass } from 'features/setup/services/SchoolYear';
import { ISchoolYearClass, defaultSchoolYearClassTemplate, ISchoolYearPeriod, ISchoolYearPeriodExam, defaultSchoolYearClass, ISchoolYearClassSubject, ISchoolYearClassSubjectSchedule, defaultSchoolYearClassSubject } from 'features/setup/models/SchoolYear';

import { ISchoolYear } from 'features/setup/models/SchoolYear';

import useEntityService, { useBasicFilterEntity } from 'features/services/Entity';

import { BasicTextFilterForm, defaultBasicTextFilterProps } from 'components/ui/BasicTextFilterForm';

import { MdOutlineAdd } from 'react-icons/md';

import SyncIcon from "@mui/icons-material/Sync";

// import WidgetSummary from './widgets/WidgetSummary';
// import WidgetBarChart from './widgets/WidgetBarChart';
// import WidgetPieChart from './widgets/WidgetPieChart';
import { Button } from '@mui/material';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';
import {
    DateSelectArg,
    EventApi,
    EventClickArg,
    EventChangeArg, EventInput
} from '@fullcalendar/core';
import { isFalsy } from 'utility-types';
import { parse, format } from 'date-fns';
import { Enum_DAY_WEEK, IEnumerationItem } from 'features/configuration/models/Enumeration';
import { IRegistration } from 'features/production/models/Registration';


export interface ExcludeSubjectRegistrationsFormProps {
    schoolYearClassSubjects: ISchoolYearClassSubject[],
    registrations: IRegistration[],

    excludedRegistrationIds: number[],

    onExludeRegistration: (registrationId: number) => void;
    onIncludeRegistration: (registrationId: number) => void;

    onSubjectChange: (schoolYearClassSubjectId: number) => void;
    //onClose: (excludedSubjects: { id: number, schoolYearClassSubjectId: number }[]) => void;
}


export const ExcludeSubjectRegistrationsForm: React.FC<ExcludeSubjectRegistrationsFormProps> = ({
    schoolYearClassSubjects, registrations, excludedRegistrationIds,
    onExludeRegistration, onIncludeRegistration, onSubjectChange }: ExcludeSubjectRegistrationsFormProps) => {

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const { compareName } = useUtils();

    const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);

    const { language: lg, schoolYears, applicationSetup, roleEntities } = useRecoilValue(currentUserSessionAtom);

    const { retrieveEntity, retrieveData, openEntityActionDrawer, openEntityPrintDrawer, openEntityPrintDrawerEx,
        checkEntityExpressionSyntax, checkEntitySaveAuthorization, hasEntityAuthorization } = useEntityService();


    const [schoolYearClassSubjectId, setSchoolYearClassSubjectId] = useState(0);

    const [isSearchBoxShow, setIsSearchBoxShow] = useRecoilState(isSearchBoxShowAtom);
    const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);
    const basicFilterSchoolYearClass = useBasicFilterSchoolYearClass(
        async (event: React.MouseEvent<unknown>, row: ISchoolYearClass) => {
            setIsSearchBoxShow(false);

            const { id, name, schoolYearId } = row;

        }
    );



    useEffect(() => {
        setCurrentFormName(t('Time table'));
        setCurrentBasicTextFilterProps(basicFilterSchoolYearClass);

    }, []);

    useEffect(() => {
        async function _() {

            //const dash = await getSchoolYearDashboard(applicationSetup.currentSchoolYearId);
            //const schoolYear = schoolYears.find(s => s.id === applicationSetup.currentSchoolYearId);
            //setSchoolYearName(schoolYear?.name || '');

            //setDashboard(dash);     
        }
        _();
    }, []);





    const [openSchoolYearClassSubjectSchedule, setOpenSchoolYearClassSubjectSchedule] = useState<boolean>(false);
    const handleClickAddSchoolYearClassSubjectSchedule = (event: any) => {
        setOpenSchoolYearClassSubjectSchedule(true);
    }

    const handleOkSchoolYearClassSubjectSchedule = (event: React.MouseEvent<unknown>) => {

        setOpenSchoolYearClassSubjectSchedule(false);
    }



    return (
        <Box sx={{ mx: 0.1 }}>
            <Grid container rowSpacing={1} columnSpacing={3}>
                <Grid item xs={12}>
                    <Stack flexDirection='column'>
                        <Box sx={{ mt: 1, width: '100%' }}
                            key={`${(schoolYearClassSubjects || []).map(s => s.schoolYearTemplateSubjectLongName).join('-')}`} >
                            <TextField select onChange={(e) => {
                                const value = parseInt(e.target.value);
                                setSchoolYearClassSubjectId(value);
                                onSubjectChange(value);
                            }}
                                value={schoolYearClassSubjectId} sx={{ width: 'calc(50% - 8px)' }}
                                id="schoolYearClassSubjectId"
                                label={t('Subject')} inputProps={{ readOnly: false }} focused >
                                <MenuItem key={0} value={0}>::::</MenuItem>
                                {schoolYearClassSubjects && schoolYearClassSubjects.map(
                                    (x, idx) => <MenuItem key={x.id} value={x.id}>{x.schoolYearTemplateSubjectLongName}</MenuItem>)
                                }
                            </TextField>
                        </Box>
                        <Box sx={{ mt: 1, width: '100%' }} >
                            <Typography variant="h6" id="tableTitle" color="primary" noWrap
                                sx={{ ...typographyGroupBoxStyling }}>
                                {`${t('List of students who attend the subject')}`}
                            </Typography>
                        </Box>
                        <Box sx={{ mt: 1, width: '100%' }} >
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                <Chip
                                    label={t('All students')} variant='filled' 
                                    sx={{ m: 0.5, border: `1px solid ${theme.palette.success.main}` }}
                                    color={'success'}
                                    deleteIcon={<UndoIcon sx={{ color: theme.palette.warning.main }} />}
                                    onDelete={() => { onExludeRegistration(0) }}
                                />
                                {(registrations ?? [])
                                    .filter(r => !(excludedRegistrationIds ?? []).includes(r.id))
                                    .sort((a, b) => compareName(
                                        lg.includes('fr') ? (a.fullNameFR || '') : (a.fullNameEN || ''),
                                        lg.includes('fr') ? (b.fullNameFR || '') : (b.fullNameEN || '')
                                    ))
                                    .map(r => (<Chip key={r.id}
                                        label={lg.includes('fr') ? r.fullNameFR : r.fullNameEN}
                                        sx={{ m: 0.5, border: `1px solid ${theme.palette.success.main}` }}
                                        deleteIcon={<UndoIcon sx={{ color: theme.palette.warning.main }} />}
                                        onDelete={() => { onExludeRegistration(r.id) }}
                                    />
                                    ))}
                            </Stack>
                        </Box>
                        <Box sx={{ mt: 3, width: '100%' }} >
                            <Typography variant="h6" id="tableTitle" color="primary" noWrap
                                sx={{ ...typographyGroupBoxStyling }}>
                                {`${t('List of students who do not attend the subject')}`}
                            </Typography>
                        </Box>
                        <Box sx={{ mt: 1, width: '100%' }} >
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                <Chip
                                    label={t('All students')} variant='filled' 
                                    sx={{ m: 0.5, border: `1px solid ${theme.palette.warning.main}` }}
                                    color={'warning'}
                                    deleteIcon={<CheckCircleIcon sx={{ color: theme.palette.success.main }} />}
                                    onDelete={() => { onIncludeRegistration(0) }}
                                />
                                {(registrations ?? [])
                                    .filter(r => (excludedRegistrationIds ?? []).includes(r.id))
                                    .sort((a, b) => compareName(
                                        lg.includes('fr') ? (a.fullNameFR || '') : (a.fullNameEN || ''),
                                        lg.includes('fr') ? (b.fullNameFR || '') : (b.fullNameEN || '')
                                    ))
                                    .map(r => (<Chip key={r.id}
                                        label={lg.includes('fr') ? r.fullNameFR : r.fullNameEN}
                                        sx={{ m: 0.5, border: `1px solid ${theme.palette.warning.main}` }}
                                        deleteIcon={<CheckCircleIcon sx={{ color: theme.palette.success.main }} />}
                                        onDelete={() => { onIncludeRegistration(r.id) }} />
                                    ))}
                            </Stack>
                        </Box>

                    </Stack>
                </Grid>
            </Grid>

        </Box>
    )
}
